module.exports = __webpack_public_path__ + "static/thumbnail-videos-670ebdc2167a14b90b2766c9093b8d4f.jpg";